// function myFunction() {
//   var num = 0.0009999999;
//   var a = Number(((num * 1000000) / 1000000).toFixed(6));
//   var b = floor10(num, -6);

//   var n = a + "<br>" + b + "<br>";

//   document.getElementById("demo").innerHTML=n;
// }


const decimalAdjust = (type: string, value, exp) => {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

// Decimal round
// const round10 = (value, exp) => decimalAdjust('round', value, exp);
// Decimal floor
export const floor10 = (value, exp) => decimalAdjust('floor', value, exp);
// Decimal ceil
// const ceil10 = (value, exp) => decimalAdjust('ceil', value, exp);
